module.exports = __webpack_public_path__ + "img/index-section7-award9.9cabec99.png";